import React, { useEffect } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Lyudmila } from './components/Lyudmila';
import { Advantages } from './components/Advantages';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Создание нового сайта';
  }, []);
  return <div className="min-h-screen bg-background text-primary" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Lyudmila data-id="element-5" />
        <Advantages data-id="element-6" />
        <Services data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Contact data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}